export const TASK_DATE_FORMAT = 'dddd: d MMMM, HH:mm';
export const TABLE_DATE_TIME_FORMAT = 'dd-MM-yyyy HH:mm';
export const TABLE_DATE_FORMAT = 'dd-MM-yyyy';
export const TABLE_DATE_TIME_FORMAT_DETAILED = 'dd-MM-yyyy HH:mm:ss.SSS';
export const FLOW_PICKER_WAIT_UNTIL_FROMAT = 'HH:mm:ss';
export const FLOW_EVENT_PICKER = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";